module.exports = __webpack_public_path__ + "static/media/homeBuilders.632cc4d4.svg";